import { IEmbedSettings, models } from "powerbi-client";
import { EmbedProps, EmbedType } from "powerbi-client-react";
import React, { useContext } from "react";

import { AppConfigContext } from "../core/configuration/Configuration";
import { PowerBIReportProps } from "./common/PowerBIReport";

const defaultSettings: IEmbedSettings = {
    navContentPaneEnabled: false,
    filterPaneEnabled: false,
    layoutType: models.LayoutType.Custom,
    background: models.BackgroundType.Transparent,
    customLayout: {
        displayOption: models.DisplayOption.FitToPage
    }
};

type ReportConfig = EmbedProps["embedConfig"];

export const useReportConfig = ({ filters, settings }: PowerBIReportProps) => {
    const appConfigContext = useContext(AppConfigContext);

    const [reportConfig, setReportConfig] = React.useState<ReportConfig>({
        type: EmbedType.Report,
        embedUrl: undefined,
        tokenType: models.TokenType.Embed,
        id: appConfigContext.buzzOrderAzureReportConfig.reportId,
        accessToken: undefined,
        settings: { ...defaultSettings, ...settings },
        filters: filters
    });

    return {
        reportConfig,
        setReportConfig
    };
};
